import { Layout } from "antd";
import dayjs from "dayjs";
import _ from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { createGlobalStyle } from "styled-components";

import { Button } from "@components/Button";
import { Text } from "@components/Text";
import { BlockItem } from "@pages/PreviewPage/BlockItem";
import { WidgetItem } from "@pages/PreviewPage/WidgetItem";
import { setCampaignPreview } from "@redux/reducers/campaignPreview.reducers";
import { COLOR_WHITE } from "@static/COLORS";
import { fetchAPI } from "@utils/https/fetchAPI";

const GlobalStyle = createGlobalStyle`
  #root, body {
    overflow: auto;
    background-color: black;
  }
`;

const Container = styled(Layout)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background: black;
`;

const AdsLayout = styled.div`
  position: relative;
  width: ${({ width = "600" }) => width}px;
  height: ${({ height = "600" }) => height}px;
  box-sizing: border-box;
`;

const ContainerInteract = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  flex-grow: 0;
`;

const LetStartButton = styled(Button)`
  width: 100px;
  height: 100px;
  border-radius: 200px;
  color: ${COLOR_WHITE};
  border: 2px solid ${COLOR_WHITE};
`;

export default () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleNextMediaRefs = useRef([]);

  const params = useParams();
  // const campaignId = _.get(params, ["id"]);

  const [isReady, setIsReady] = useState(false);
  const [campaign, setCampaign] = useState([]);
  const [campaignElapsedTime, setCampaignElapsedTime] = useState(0);
  const [currentCampaignIndex, setCurrentCampaignIndex] = useState(0);
  const intervalRef = useRef(null);
  const [playCampaignCount, setPlayCampaignCount] = useState(1);

  const [isInteract, setIsInteract] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const currentCampaign = _.get(campaign, [currentCampaignIndex]);
  //   const currentCampaignMaxDuration = _.get(currentCampaign, ["max_duration"]);

  const campaignPreview = useSelector(({ campaignPreview }) => {
    return _.get(campaignPreview, ["data"]);
  });
  const widgets = _.get(campaignPreview, ["widgets"]);

  const initData = async () => {
    const results = _.chain(campaignPreview)
      .thru((item) => {
        return [{ ...item }];
      })
      .filter((item) => {
        const adsBlocks = _.get(item, ["adsBlocks"]);
        return (
          _.size(adsBlocks) > 0 &&
          _.every(adsBlocks, (block) => !_.isEmpty(block.blockMedias))
        );
      })
      .map((item) => {
        const adsBlocks = _.chain(item)
          .get("adsBlocks")
          .map((block) => {
            const filterMediaBlocks = _.chain(block)
              .get("blockMedias")
              .filter((blockMediaItem) => {
                const endDate = _.get(blockMediaItem, "end_date");
                return !dayjs(endDate).isBefore(dayjs());
              })
              .value();

            return { ...block, blockMedias: filterMediaBlocks };
          })
          .map((block) => {
            const updatedBlockMedias = _.chain(block)
              .get(["blockMedias"])
              .map((item, index) => {
                const rounds = _.get(item, ["repeat"]);
                return _.times(rounds, () => ({
                  ...item,
                }));
              })
              .flatMap()
              .value();
            return {
              ...block,
              blockMedias: updatedBlockMedias,
            };
          })
          .value();

        // console.log("adsBlocks :>> ", adsBlocks);
        return { ...item, adsBlocks };
      })
      .map((item) => {
        const maxDuration = _.chain(item)
          .get(["adsBlocks"])
          .map((item) => {
            const blockMedias = _.get(item, ["blockMedias"]);
            return _.sumBy(blockMedias, "duration");
          })
          .max()
          .value();
        return { ...item, max_duration: maxDuration };
      })
      .value();

    console.log("results :>> ", results);
    setIsLoading(false);
    setIsReady(_.isEmpty(results) ? false : true);
    setCampaign(results);
  };

  useEffect(() => {
    initData();
  }, []);

  useEffect(() => {
    if (_.size(campaign) > 0 && isInteract) {
      const timer = setTimeout(() => {
        handleNextCampaign();
      }, _.get(campaign, [currentCampaignIndex, "max_duration"]) * 1000);

      intervalRef.current = setInterval(() => {
        setCampaignElapsedTime((prev) => prev + 1);
      }, 1000);

      return () => {
        clearTimeout(timer);
        clearInterval(intervalRef.current);
      };
    }
  }, [playCampaignCount, currentCampaignIndex, campaign, isInteract]);

  const handleNextCampaign = () => {
    setCampaignElapsedTime(0);
    setCurrentCampaignIndex((prevIndex) => {
      const nextIndex = (prevIndex + 1) % _.size(campaign);
      if (nextIndex === 0) {
        setPlayCampaignCount((prev) => prev + 1);
      }
      return nextIndex;
    });
  };

  const handleSkip = () => {
    // เรียกฟังก์ชัน handleNextMedia ของ BlockItem ทุกบล็อก
    handleNextMediaRefs.current.forEach((handleNextMedia) => {
      if (handleNextMedia) handleNextMedia();
    });
  };

  return (
    <>
      <GlobalStyle />
      <Container>
        {_.isNil(campaignPreview) && (
          <div
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Text fontSize="72px" fontWeight="600" color={COLOR_WHITE}>
              ไม่พบข้อมูล
            </Text>
            <Button onClick={() => navigate("/campaigns")}>
              <Text
                align="end"
                fontSize="16px"
                fontWeight="600"
                color={COLOR_WHITE}
                textDecorationLine="underLine"
              >
                back
              </Text>
            </Button>
          </div>
        )}
        {isReady ? (
          <AdsLayout
            width={_.get(currentCampaign, ["width"])}
            height={_.get(currentCampaign, ["height"])}
          >
            {!isInteract && (
              <ContainerInteract>
                <LetStartButton onClick={() => setIsInteract(true)}>
                  <Text
                    color={COLOR_WHITE}
                    fontWeight="600"
                  >{`Let's Start`}</Text>
                </LetStartButton>
              </ContainerInteract>
            )}

            {isInteract &&
              !_.isEmpty(widgets) &&
              _.chain(widgets)
                .map((item, index) => {
                  return <WidgetItem key={index} widget={item} index={index} />;
                })
                .value()}

            {isInteract && (
              <Button
                style={{
                  position: "fixed",
                  bottom: 50,
                  right: 50,
                  background: "white",
                  zIndex: 2000,
                }}
                onClick={handleSkip}
              >
                <Text>Skip {" >>"}</Text>
              </Button>
            )}
            {isInteract &&
              !_.chain(currentCampaign).get(["adsBlocks"]).isEmpty().value() &&
              _.chain(currentCampaign)
                .get(["adsBlocks"], [])
                .map((item, index) => {
                  return (
                    <BlockItem
                      index={index}
                      key={index}
                      block={item}
                      playCampaignCount={playCampaignCount}
                      handleNextMediaRef={(el) =>
                        (handleNextMediaRefs.current[index] = el)
                      }
                    />
                  );
                })
                .value()}
          </AdsLayout>
        ) : null}
      </Container>
    </>
  );
};
